export function shouldUpdateScroll({ prevRouterProps, routerProps }) {
  if (prevRouterProps) {
    window.scrollTo(0, 0); // Force scroll to top
  }
  return false; // Prevent default scroll restoration
}
